import 'whatwg-fetch';
import config from '../../config/config';

const {
    API_SHIPPING_CALCULATE_URL,
} = config;

const consumerKey = process.env.REACT_APP_API_CONSUMER_KEY;
const consumerSecret = process.env.REACT_APP_API_CONSUMER_SECRET;

export const shippingApi = {
    calculate: async (cartItems, addressFields) => {
        const queryParams = new URLSearchParams({
            consumer_key: consumerKey,
            consumer_secret: consumerSecret,
        }).toString();

        const fetchOptions = {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                cart_items: cartItems.map(item => ({
                    productId: item.productId || item.id,
                    variationId: item.virtual ? 0 : (parseInt(item.variationId || item.variation_id, 10) || 0),
                    quantity: item.quantity || 1,
                })),
                address_fields: {
                    country: addressFields.country || 'RU',
                    fullAddress: addressFields.fullAddress || '',
                    city: addressFields.city || '',
                    stateCode: addressFields.stateCode || '',
                    geoLat: addressFields.geoLat || '',
                    geoLon: addressFields.geoLon || '',
                    postal_code: addressFields.postal_code || addressFields.postalCode || '',
                },
            }),
        };

        const response = await fetch(
            `${API_SHIPPING_CALCULATE_URL}?${queryParams}`,
            fetchOptions
        );

        if (!response.ok) {
            throw new Error(`HTTP ${response.status}: ${response.statusText}`);
        }

        const result = await response.json();

        if (!result.success) {
            throw new Error(result.message || 'Ошибка расчёта доставки');
        }

        return {
            shippingOptions: result.data.shipping_options || {},
            minDelivery: result.data.min_delivery || null,
            minPickup: result.data.min_pickup || null,
            cacheKey: result.data.cache_key || null,
            timestamp: result.timestamp,
        };
    },

    fetchDeliveryPoints: async ({ shippingMethod, address, cartItems }) => {
        const params = new URLSearchParams();
        params.append('action', 'react_delivery');
        params.append('shipping_method', shippingMethod || 'cdek');
        params.append('country', address.country || 'RU');
        params.append('state', address.stateCode || '');
        params.append('stateCode', address.stateCode || '');
        params.append('city', address.city || '');
        params.append('postal_code', address.postalCode || address.postal_code || '');

        (cartItems || []).forEach((item, i) => {
            params.append(`cart_items[${i}][productId]`, item.productId || item.id);
            params.append(`cart_items[${i}][quantity]`, item.quantity || 1);
            params.append(`cart_items[${i}][variationId]`, item.virtual ? 0 : (parseInt(item.variationId || item.variation_id, 10) || 0));
        });

        const ajaxUrl = process.env.NODE_ENV === 'development'
            ? '/wp-admin/admin-ajax.php'
            : `${process.env.REACT_APP_API_URL}/wp-admin/admin-ajax.php`;
        const response = await fetch(ajaxUrl, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
            },
            body: params.toString(),
        });

        if (!response.ok) {
            throw new Error(`HTTP ${response.status}: ${response.statusText}`);
        }

        const result = await response.json();

        return {
            options: result.options || [],
            points: result.points || [],
        };
    },
};